import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Divider from '@mui/material/Divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RowTable from './RowTable';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import CloseIcon from '@mui/icons-material/Close';
import {Owner,Bill} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import useStyles from './Styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';
//import Title from './Title';

interface Props {
    bill: Bill,
    close():void,
    isOpen:boolean,
    owner:Owner,
}

const BillDetail = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
    const classes = useStyles();
    if( !props.isOpen ){
        return (null);
    }

    let classStatus = "cl cl-green";
    if( props.bill.status==="0" ){
        classStatus = "cl cl-orange";
    }

    const download = (e: React.MouseEvent<HTMLElement>)=>{
        if( !e.currentTarget.dataset.type ){
            return;
        }
        let filename = "領収書";
        if( e.currentTarget.dataset.type==="bill" ){
            filename = "明細書";
        }
        //const billUrl = Ajax.getUrl()+"?mod=payment&act=sheet&type=bill&bill_id="+props.bill.bill_id;
        //const receiptUrl = Ajax.getUrl()+"?mod=payment&act=sheet&type=receipt&bill_id="+props.bill.bill_id;
    
        Ajax.download("payment/sheet",{type:e.currentTarget.dataset.type,bill_id:props.bill.bill_id,filename:filename},(res:any)=>{
            if( res.ok ){
                //console.log("ok");
            }
        });
    }


    return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}
		>
			<DialogTitle color="primary">支払履歴詳細</DialogTitle>
			<DialogContent>
				<div style={{textAlign:"right"}}>受付番号：{props.bill.bill_id}</div>
				<Divider/>
				<Table style={{marginBottom:"1em"}}>
					<TableBody>
						<RowTable name="商品売上" value={
							<div style={{textAlign:"right",fontSize:"140%"}}>
							{Tools.comma(props.bill.sales)}円
							</div>
						}/>
						<RowTable name="販売手数料" value={
							<div style={{textAlign:"right",fontSize:"140%"}}>
							-{Tools.comma(props.bill.fee)}円
							</div>
						}/>
						<RowTable name="商品返送料等" value={
							<div style={{textAlign:"right",fontSize:"140%"}}>
							-{Tools.comma(props.bill.fee_etc)}円
							</div>
						}/>
						<RowTable name="支払手数料" value={
							<div style={{textAlign:"right",fontSize:"140%"}}>
							-{Tools.comma(props.bill.cost)}円
							</div>
						}/>
						<RowTable name="振込金額" value={
							<div style={{textAlign:"right",fontSize:"140%"}}>
							{Tools.comma(props.bill.amount)}円
							</div>
						}/>
					</TableBody>
				</Table>

				<Grid container spacing={4}>
					<Grid item xs={12} md={6}>
						<div style={{padding:"0em",paddingTop:"0.7em"}}>
							<Table>
								<TableBody>
									<TableRow>
										<TableCell className={classes.tableCellNowrap+' '+classes.rowLabel}>申請日</TableCell>
										<TableCell className={classes.tableCellNowrap}>{props.bill.apply_date}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCellNowrap+' '+classes.rowLabel}>支払日</TableCell>
										<TableCell className={classes.tableCellNowrap}>
                                        {props.bill.pay_date && <span>{props.bill.pay_date}</span>}
                                        {!props.bill.pay_date && props.bill.status!=='9' && <span className={classes.mitei}>未定</span>}
										{!props.bill.pay_date && props.bill.status==='9' && <span className={classes.funou}>支払不能</span>}

										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCellNowrap+' '+classes.rowLabel}>振込口座</TableCell>
										<TableCell className={classes.tableCellNowrap}>
										{props.bill.bank_name}{props.bill.bank_store}<br/>
								{props.bill.bank_code}<br/>
								{props.bill.bank_signature}<br/>

										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell className={classes.tableCellNowrap+' '+classes.rowLabel}>状態</TableCell>
										<TableCell className={classes.tableCellNowrap}>
											{props.bill.status!=='9' && <span className={classStatus}>{props.bill.status_label}</span>}
											{props.bill.status==='9' && <CloseIcon style={{verticalAlign:'middle'}} className={classes.funou}/>}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</div>
					</Grid>
					{props.bill.status!=='9' &&
					<Grid item xs={12} md={6}>
						<div>
							{props.bill.status!=="1" ? (
							<div style={{fontSize:"90%"}}>
								<div className={classes.rowLabel}>領収書・明細書</div>
								状態が「済」になるとダウンロードできます<br/>
								<Button variant="outlined" color="primary" disabled={true} style={{width:"100%",marginTop:"1em",marginBottom:"0.5em"}}><FontAwesomeIcon icon="file-download" style={{marginRight:"0.5em"}}/>明細書をダウンロード</Button>
								<Button variant="outlined" color="primary" disabled={true} style={{width:"100%"}}><FontAwesomeIcon icon="file-download" style={{marginRight:"0.5em"}}/>領収書をダウンロード</Button>
							</div>
							):(
							<div style={{fontSize:"90%"}}>
								領収書等がダウンロードできます<br/>
								<Button variant="outlined" color="primary" onClick={download} data-type="bill" style={{width:"100%",marginTop:"1em",marginBottom:"0.5em"}}><FontAwesomeIcon icon="file-download" style={{marginRight:"0.5em"}}/>明細書をダウンロード</Button>
								<Button variant="outlined" color="primary" onClick={download} data-type="receipt" style={{width:"100%"}}><FontAwesomeIcon icon="file-download" style={{marginRight:"0.5em"}}/>領収書をダウンロード</Button>
							</div>
							)}
						</div>
					</Grid>
					}
					{props.bill.reason &&
					<Grid item xs={12} md={6}>
						<div style={{padding:'1em',fontSize:'85%',backgroundColor:'#FFEEEE'}}>
							以下の理由によりこの支払申請は実行できませんでした
							<p><b style={{color:'#FF3333'}}>・{props.bill.reason}</b></p>
							詳細はメールでお知らせいたしましたのでご確認ください
						</div>
					</Grid>
					}
				</Grid>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='閉じる' onClick1={props.close} bottom={0}/>
			</DialogActions>
		</Dialog>
    );
}

export default BillDetail;
